// extracted by mini-css-extract-plugin
export default {"AggregateLabels":"parent-issue-group-header-label-module__AggregateLabels--APIGA","ParentIssueTitle":"parent-issue-group-header-label-module__ParentIssueTitle--N1vGZ"};